export default "__VITE_ASSET__C7RKOop9__"